import { css } from 'styled-components'

export const LabelCSS = css`
  font-weight: ${props => props.theme.font.weight.s};
  display: block;
  margin-bottom: 3px;
  margin-left: 15px;
`

export const InputCSS = css`
  -webkit-appearance: none;
  width: 100%;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 15px;
  border: 1px solid #DBDBDB;
  outline: none;
  height: 45px;
  line-height: 45px;

  &::placeholder {
    opacity: .5;
  }
`

export const TextareaCSS = css`
  ${InputCSS};
  height: 310px;
  line-height: 25px;
  padding-top: 10px;
`